/* LukyNeko, Lucky Bag pack page logic (sections lucky-bag-packs, lucky-bag-story). Our own file, loaded by the section.
   Port of the Claude Design canvas "Product page" logic: packs, Luky's mix, chooser with S/M and L/XL counters,
   size question, add to cart, "Added to your cart" sheet. Gift set count is kept by window.LNGift (lukyneko-custom.js). */
(function () {
  'use strict';

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tpl(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function money(cents, format) {
    var v = (cents || 0) / 100;
    function d(n, dec, th, ds) { var p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); }
    var m = (format || '{{amount}}').match(/\{\{\s*(\w+)\s*\}\}/), out;
    switch (m ? m[1] : 'amount') {
      case 'amount_with_comma_separator': out = d(v, 2, '.', ','); break;
      case 'amount_no_decimals': out = d(v, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = d(v, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = d(v, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = d(v, 2, ' ', ','); break;
      default: out = d(v, 2, ',', '.');
    }
    return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }
  var IC = {
    x: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12"></path><path d="M18 6L6 18"></path></svg>',
    xs: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 7l10 10"></path><path d="M17 7L7 17"></path></svg>',
    minus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 12h12"></path></svg>',
    plus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 6v12"></path><path d="M6 12h12"></path></svg>',
    arrow: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path></svg>',
    shuffle: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 3h5v5"></path><path d="M4 20L21 3"></path><path d="M21 16v5h-5"></path><path d="M15 15l6 6"></path><path d="M4 4l5 5"></path></svg>',
    check: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"></path></svg>'
  };

  function Packs(root) {
    var self = this;
    this.root = root;
    this.D = JSON.parse(qs('[data-lbp-json]', root).textContent);
    this.D.designs = this.D.designs.filter(function (x) { return !!x; });
    this.T = this.D.t;
    this.ovs = qs('[data-lbp-ovs]', root);
    document.body.appendChild(this.ovs);
    var mix = String(this.D.mix || '').split(',').map(function (x) { return parseInt(x, 10) - 1; }).filter(function (i) { return i >= 0 && i < self.D.designs.length; });
    var start = this.D.defaultPack || 2;
    if (!this.packOk(start)) start = 1;
    this.st = { pack: start, open: false, mix: mix.length ? mix : [0, 1, 2, 3, 4, 5, 0], picks: null, ov: null };
    this.bind();
    this.render();
    window.LBP = this;
  }

  Packs.prototype.packOk = function (k) {
    var p = this.D.packs[k - 1];
    if (!p) return false;
    return !(p.free > 0 && !this.D.gift.ok);
  };
  Packs.prototype.pk = function () { return this.D.packs[this.st.pack - 1]; };
  Packs.prototype.money = function (c) { return money(c, this.D.money); };
  Packs.prototype.d = function (i) { return this.D.designs[i]; };
  Packs.prototype.avail = function (i, s) { var v = this.d(i) && this.d(i)[s]; return !!(v && v.ok && v.max > 0); };
  Packs.prototype.anyAvail = function (i) { return this.avail(i, 'sm') || this.avail(i, 'xl'); };
  Packs.prototype.ok = function (x) { return !!(x && x.d != null && x.s); };
  Packs.prototype.done = function () { var self = this; return (this.st.picks || []).filter(function (x) { return self.ok(x); }).length; };
  Packs.prototype.missing = function () { return this.st.picks ? this.pk().n - this.done() : 0; };
  Packs.prototype.cnt = function (i, s) { return (this.st.picks || []).filter(function (x) { return x && x.d === i && (!s || x.s === s); }).length; };
  Packs.prototype.resize = function (a, n) { var b = a.slice(0, n); while (b.length < n) b.push(null); return b; };
  Packs.prototype.pending = function () { return !!(this.D.gift.pending && this.pk().free > 0); };

  /* the mix used before the customer chooses: first n of the mix list, sold out designs swapped */
  Packs.prototype.mixFor = function (n, size) {
    var self = this, out = [], used = {};
    var order = this.st.mix.slice();
    for (var i = 0; i < this.D.designs.length; i++) order.push(i);
    var j = 0;
    while (out.length < n && j < order.length * 3) {
      var di = order[j % order.length]; j++;
      var okd = size ? self.availQty(di, size, out) : self.anyAvail(di);
      if (okd) out.push(di);
    }
    return out;
  };
  Packs.prototype.availQty = function (di, size, list) {
    var v = this.d(di) && this.d(di)[size]; if (!v || !v.ok) return false;
    var used = list.filter(function (x) { return x === di; }).length;
    return used < v.max;
  };

  Packs.prototype.setPack = function (k) {
    if (!this.packOk(k)) return;
    this.st.pack = k;
    if (this.st.picks) this.st.picks = this.resize(this.st.picks, this.pk().n);
  };

  Packs.prototype.shuffle = function () {
    var self = this, a = this.D.designs.map(function (x, i) { return i; }).filter(function (i) { return self.anyAvail(i); });
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; }
    var m = []; for (var n = 0; n < 7; n++) m.push(a[n % a.length]);
    this.st.mix = m; this.st.picks = null;
    this.render();
  };

  Packs.prototype.addPick = function (di, s) {
    var a = this.st.picks; if (!a) return;
    for (var i = 0; i < a.length; i++) { if (!this.ok(a[i])) { a[i] = { d: di, s: s }; break; } }
  };
  Packs.prototype.rmPick = function (di, s) {
    var a = this.st.picks; if (!a) return;
    for (var i = a.length - 1; i >= 0; i--) { if (a[i] && a[i].d === di && a[i].s === s) { a.splice(i, 1); a.push(null); return; } }
  };
  Packs.prototype.rmAt = function (i) { var a = this.st.picks; if (!a) return; a.splice(i, 1); a.push(null); };

  Packs.prototype.allSize = function (s) {
    var self = this, ids = this.mixFor(this.pk().n, s);
    if (ids.length < this.pk().n) { this.openEd(); return; }
    this.st.picks = ids.map(function (di) { return { d: di, s: s }; });
    this.add();
  };

  Packs.prototype.openEd = function () {
    if (!this.st.picks) this.st.picks = this.resize([], this.pk().n);
    this.open('ed');
  };

  /* ---------- rendering ---------- */
  Packs.prototype.render = function () {
    var self = this, T = this.T, p = this.pk(), root = this.root;
    qsa('.lbp-pk', root).forEach(function (el) {
      var k = parseInt(el.getAttribute('data-pack'), 10), sel = k === self.st.pack, open = sel && self.st.open;
      el.classList.toggle('is-sel', sel); el.classList.toggle('is-open', open);
      var b = qs('.lbp-pkh', el); b.setAttribute('aria-pressed', sel ? 'true' : 'false'); b.setAttribute('aria-expanded', open ? 'true' : 'false');
      var ins = qs('[data-ins]', el); if (ins) ins.hidden = !open;
      var mt = qs('[data-more-t]', el); if (mt) mt.textContent = open ? T.insideHide : T.insideShow;
    });
    var pend = this.pending();
    var chip = qs('.lbp-dchip', root);
    if (chip) { chip.classList.toggle('is-pending', pend); qs('[data-lbp-d1]', root).hidden = pend; }
    var t1 = qs('[data-trust1]', root); if (t1) t1.textContent = pend ? T.capShip : T.trust1;

    /* designs box */
    var n = p.n, custom = !!this.st.picks, miss = this.missing(), dn = custom ? this.done() : 0, h = '';
    h += '<div class="lbp-dboxh"><span class="lbp-dboxt">' + esc(custom ? T.yoursTitle : T.mixTitle) + '</span><span class="lbp-chip">' + esc(tpl(T.capPairs, { n: n })) + '</span></div>';
    h += '<span class="lbp-gs">' + esc(custom ? (miss ? tpl(T.yoursProgress, { k: dn, n: n, r: miss }) : tpl(T.yoursDone, { n: n })) : T.mixSub) + '</span>';
    if (!custom) {
      var groups = {}, order = [];
      var sz = this.st.size || null;
      this.mixFor(n, sz).forEach(function (di) { if (groups[di] == null) { groups[di] = 0; order.push(di); } groups[di]++; });
      h += '<div class="lbp-mixth">' + order.map(function (di) { var d = self.d(di); return '<span class="lbp-mx"><img src="' + esc(d.img) + '" alt="' + esc(d.name) + '" width="56" height="56"><span class="lbp-mxk">×' + groups[di] + '</span></span>'; }).join('') + '</div>';
      if (T.sizeLabel) {
        h += '<div class="lbp-szrow"><span class="lbp-szl">' + esc(T.sizeLabel) + '</span><div class="lbp-szbtns">' + ['sm', 'xl'].map(function (s) {
          var ok = self.mixFor(n, s).length >= n, on = sz === s;
          return '<button type="button" class="lbp-szb' + (on ? ' on' : '') + '" data-act="size" data-s="' + s + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (ok ? '' : ' disabled') + '><b>' + esc(s === 'sm' ? T.sizeSm : T.sizeXl) + '</b><span>' + esc(s === 'sm' ? T.sizeSmRange : T.sizeXlRange) + '</span></button>';
        }).join('') + '</div>' + (T.sizeHint ? '<span class="lbp-szh">' + esc(T.sizeHint) + '</span>' : '') + '</div>';
      }
    } else {
      var m = {}, ord = [];
      this.st.picks.forEach(function (x) { if (!self.ok(x)) return; var key = x.d + '|' + x.s; if (m[key] == null) { m[key] = 0; ord.push(key); } m[key]++; });
      h += '<div class="lbp-pchips">' + ord.map(function (key) { var a = key.split('|'), d = self.d(+a[0]); return '<span class="lbp-pchip"><img src="' + esc(d.img) + '" alt="" width="28" height="28">' + esc(d.name) + ' <span class="z">' + esc(a[1] === 'sm' ? T.sizeSm : T.sizeXl) + '</span>' + (m[key] > 1 ? ' ×' + m[key] : '') + '</span>'; }).join('') + '</div>';
    }
    h += '<button type="button" class="lbp-primary" data-act="ed">' + esc(custom ? (miss ? T.btnFinish : T.btnChange) : T.btnChoose) + '</button>';
    h += '<button type="button" class="lbp-ghost" data-act="shuffle">' + IC.shuffle + ' ' + esc(T.btnSurprise) + '</button>';
    if (p.free > 0) {
      var I = this.D.img, g = this.D.gift, counter = '';
      if (!g.pending && g.left > 0 && g.left < g.under) counter = '<span class="lbp-gcount">' + esc(tpl(T.counter, { n: g.left })) + '</span>';
      h += '<div class="lbp-gift"><div class="th">' + [I.bag, I.card, I.sticker].filter(Boolean).map(function (u) { return '<img src="' + esc(u) + '" alt="" width="46" height="46">'; }).join('') + '</div><div class="lbp-stack" style="flex:1;min-width:0"><span class="lbp-ffree">' + esc(T.giftLabel) + '</span><span class="lbp-gt">' + esc(T.giftTitle) + '</span><span class="lbp-gsub">' + esc(T.giftStrip2) + '</span>' + counter + '</div></div>';
    }
    qs('[data-lbp-dbox]', root).innerHTML = h;

    /* bar */
    qs('[data-bar1]', root).textContent = p.bar || '';
    qs('[data-bar-price]', root).textContent = this.money(p.price);
    var w = qs('[data-bar-worth]', root); w.textContent = p.worth > p.price ? this.money(p.worth) : ''; w.hidden = !(p.worth > p.price);
    qs('[data-cta]', root).textContent = (custom && miss) ? (miss === 1 ? T.pickOne : tpl(T.pickMany, { k: miss })) : T.add;

    this.renderOv();
  };

  Packs.prototype.renderOv = function () {
    var self = this, T = this.T, st = this.st, p = this.pk(), h = '';
    document.documentElement.classList.toggle('lbp-lock', !!st.ov);
    if (!st.ov) { this.ovs.innerHTML = ''; this._lastOv = null; return; }
    var same = this._lastOv === st.ov; this._lastOv = st.ov;
    var close = '<button type="button" class="lbp-xb" data-act="close" aria-label="' + esc(T.close) + '">' + IC.x + '</button>';
    if (st.ov === 'ask') {
      var smOk = this.mixFor(p.n, 'sm').length >= p.n, xlOk = this.mixFor(p.n, 'xl').length >= p.n;
      h = '<div class="lbp-ov" role="dialog" aria-modal="true" aria-label="' + esc(T.askTitle) + '"><button type="button" class="lbp-bd" data-act="close" aria-label="' + esc(T.close) + '"></button><div class="lbp-sheet"><div class="lbp-handle"></div>' +
        '<div class="lbp-sht"><span class="lbp-stack"><span class="lbp-shtt">' + esc(T.askTitle) + '</span><span class="lbp-rowsub">' + esc(tpl(T.askSub, { n: p.n })) + '</span></span>' + close + '</div>' +
        '<button type="button" class="lbp-szopt" data-act="allsm"' + (smOk ? '' : ' disabled') + '><span class="lbp-stack"><span class="a">' + esc(T.askSm) + '</span><span class="b">' + esc(T.askSmSub) + '</span></span>' + IC.arrow + '</button>' +
        '<button type="button" class="lbp-szopt" data-act="allxl"' + (xlOk ? '' : ' disabled') + '><span class="lbp-stack"><span class="a">' + esc(T.askXl) + '</span><span class="b">' + esc(T.askXlSub) + '</span></span>' + IC.arrow + '</button>' +
        '<button type="button" class="lbp-szopt" data-act="mixsizes"><span class="lbp-stack"><span class="a">' + esc(T.askMix) + '</span><span class="b">' + esc(T.askMixSub) + '</span></span>' + IC.arrow + '</button>' +
        '</div></div>';
    } else if (st.ov === 'ed') {
      var miss = this.missing(), full = miss === 0, sub = p.free === 1 ? T.sheetSub1 : (p.free > 1 ? T.sheetSub2 : T.sheetSub0);
      var basket = st.picks.map(function (x, i) {
        var fr = i >= p.pay, d = self.ok(x) ? self.d(x.d) : null;
        if (d) return '<div class="lbp-bs' + (fr ? ' fr' : '') + '"><img src="' + esc(d.img) + '" alt="' + esc(d.name) + '" width="60" height="60"><span class="sz">' + esc(x.s === 'sm' ? T.sizeSm : T.sizeXl) + '</span><button type="button" class="lbp-bx" data-act="rmat" data-i="' + i + '" aria-label="' + esc(d.name + ' ' + (x.s === 'sm' ? T.sizeSm : T.sizeXl)) + '">' + IC.xs + '</button>' + (fr ? '<span class="lbp-ft">' + esc(T.lblFree) + '</span>' : '') + '</div>';
        return '<div class="lbp-bs em' + (fr ? ' fr' : '') + '"><span class="emp">' + (i + 1) + '</span>' + (fr ? '<span class="lbp-ft">' + esc(T.lblFree) + '</span>' : '') + '</div>';
      }).join('');
      var rows = function (grp) {
        return self.D.designs.map(function (d, di) {
          if (d.grp !== grp) return '';
          var nS = self.cnt(di, 'sm'), nX = self.cnt(di, 'xl'), tot = nS + nX;
          var line = function (s, nn) {
            var v = d[s], lab = '<span class="lab">' + esc(s === 'sm' ? T.sizeSm : T.sizeXl) + '<span class="z">' + esc(s === 'sm' ? T.sizeSmRange : T.sizeXlRange) + '</span></span>';
            if (!v || !v.ok || v.max <= 0) return '<span class="lbp-r3l">' + lab + '<span class="so">' + esc(T.soldOut) + '</span></span>';
            var canAdd = !full && nn < v.max;
            return '<span class="lbp-r3l">' + lab + '<span class="lbp-st3' + (nn ? ' on' : '') + '">' +
              '<button type="button" class="lbp-b3" data-act="dec" data-d="' + di + '" data-s="' + s + '"' + (nn ? '' : ' disabled') + ' aria-label="' + esc('- ' + d.name + ' ' + (s === 'sm' ? T.sizeSm : T.sizeXl)) + '">' + IC.minus + '</button>' +
              '<span class="lbp-n3">' + nn + '</span>' +
              '<button type="button" class="lbp-b3" data-act="inc" data-d="' + di + '" data-s="' + s + '"' + (canAdd ? '' : ' disabled') + ' aria-label="' + esc('+ ' + d.name + ' ' + (s === 'sm' ? T.sizeSm : T.sizeXl)) + '">' + IC.plus + '</button>' +
              '</span></span>';
          };
          return '<div class="lbp-r3"><img src="' + esc(d.imgL || d.img) + '" alt="' + esc(d.name) + '" width="76" height="76"><span class="lbp-r3n"><span>' + esc(d.name) + '</span>' + (tot ? '<span class="cnt">' + esc(tpl(T.rowCount, { n: tot })) + '</span>' : '') + '</span><span class="lbp-r3s">' + line('sm', nS) + line('xl', nX) + '</span></div>';
        }).join('');
      };
      var hasPrn = this.D.designs.some(function (d) { return d.grp === 'p'; });
      var cta = miss ? (miss === 1 ? T.pickOne : tpl(T.pickMany, { k: miss })) : T.done;
      h = '<div class="lbp-ov" role="dialog" aria-modal="true" aria-label="' + esc(tpl(T.sheetTitle, { n: p.n })) + '"><button type="button" class="lbp-bd" data-act="close" aria-label="' + esc(T.close) + '"></button><div class="lbp-sheet lbp-sheet--ed"><div class="lbp-handle"></div>' +
        '<div class="lbp-edtop"><div class="lbp-sht"><span class="lbp-stack"><span class="lbp-shtt">' + esc(tpl(T.sheetTitle, { n: p.n })) + '</span><span class="lbp-edsub">' + esc(sub) + '</span></span>' + close + '</div>' +
        '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px"><span class="lbp-left' + (miss ? '' : ' ok') + '">' + esc(miss ? (miss === 1 ? T.leftOne : tpl(T.leftMany, { r: miss })) : T.leftDone) + '</span><span class="lbp-rowsub">' + esc(T.hintCross) + '</span></div>' +
        '<div class="lbp-bk' + (p.n > 5 ? ' n7' : '') + '">' + basket + '</div></div>' +
        '<div class="lbp-scroll"><div class="lbp-edsh"><span>' + esc(T.grpEmb) + '</span>' + (full ? '<span class="lbp-okt">' + esc(T.allPicked) + '</span>' : '') + '</div>' + rows('e') +
        (hasPrn ? '<div class="lbp-edsh lbp-edsh--2"><span>' + esc(T.grpPrn) + '</span></div>' + rows('p') : '') + '</div>' +
        '<button type="button" class="lbp-primary" data-act="eddone"' + (miss ? ' disabled' : '') + '>' + esc(cta) + '</button>' +
        '</div></div>';
    } else if (st.ov === 'cart' && this.cart) {
      var c = this.cart, gift = this.D.gift, lines = '', single = 0;
      c.items.forEach(function (it) {
        var isGift = it.handle === gift.handle;
        if (!isGift) single += it.original_line_price;
        var img = it.image || (it.featured_image && it.featured_image.url) || '';
        lines += '<div class="lbp-cl"><img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="52" height="52"><div class="lbp-cln"><span>' + esc(isGift ? T.giftTitle : it.product_title) + '</span><span class="lbp-rowsub">' + esc(isGift ? T.giftStrip2.split('.')[0] : (it.variant_title || '')) + ' · ' + esc(T.cartQty) + ' ' + it.quantity + '</span></div><div class="lbp-clp">' + (isGift ? '<span class="lbp-ffree">' + esc(T.cartGiftFree) + '</span>' : esc(self.money(it.original_line_price))) + '</div></div>';
      });
      /* pack saving = the pack discounts (title has "pack"); any other discount or code (e.g. LUCKY7) on its own line */
      var saving = 0, codes = {}, codeOrder = [];
      var addCode = function (t, a) { if (!(t in codes)) { codes[t] = 0; codeOrder.push(t); } codes[t] += a; };
      var isPack = function (da) { return da.type !== 'discount_code' && /pack/i.test(da.title || ''); };
      c.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (al) { var da = al.discount_application || {}; if (isPack(da)) saving += al.amount; else addCode(da.title || da.key || 'Code', al.amount); }); });
      (c.cart_level_discount_applications || []).forEach(function (da) { if (isPack(da)) saving += da.total_allocated_amount; else addCode(da.title || da.key || 'Code', da.total_allocated_amount); });
      var codeRows = codeOrder.map(function (t) { return codes[t] > 0 ? '<div class="lbp-tot"><span>' + esc(t) + '</span><span>\u2212' + esc(self.money(codes[t])) + '</span></div>' : ''; }).join('');
      h = '<div class="lbp-ov" role="dialog" aria-modal="true" aria-label="' + esc(T.cartAdded) + '"><button type="button" class="lbp-bd" data-act="close" aria-label="' + esc(T.close) + '"></button><div class="lbp-sheet lbp-sheet--drawer"><div class="lbp-handle"></div>' +
        '<div class="lbp-sht"><span class="lbp-shtt">' + esc(T.cartAdded) + '</span>' + close + '</div>' +
        '<span class="lbp-okpill">' + IC.check + ' ' + esc(p.bar) + '</span>' +
        '<div class="lbp-scroll lbp-stack" style="gap:10px">' + lines + '</div>' +
        '<div class="lbp-stack"><div class="lbp-tot"><span>' + esc(T.cartSingle) + '</span><span>' + esc(this.money(single)) + '</span></div>' +
        (saving > 0 ? '<div class="lbp-tot"><span>' + esc(T.cartSaving) + '</span><span>−' + esc(this.money(saving)) + '</span></div>' : '') + codeRows +
        '<div class="lbp-tot"><span>' + esc(T.cartShipping) + '</span><span>' + esc(T.cartFree) + '</span></div>' +
        '<div class="lbp-tot b"><span>' + esc(T.cartTotal) + '</span><span>' + esc(this.money(c.total_price)) + '</span></div></div>' +
        '<a class="lbp-checkout" href="' + esc(this.root_url() + 'checkout') + '">' + esc(T.cartCheckout) + '</a>' +
        '</div></div>';
    }
    var sc = qs('.lbp-scroll', this.ovs), top = sc ? sc.scrollTop : 0;
    if (same) h = h.replace('<div class="lbp-ov"', '<div class="lbp-ov lbp-ov--static"');
    this.ovs.innerHTML = h;
    var sc2 = qs('.lbp-scroll', this.ovs); if (sc2 && st.keepScroll) sc2.scrollTop = top;
    st.keepScroll = false;
  };

  Packs.prototype.root_url = function () { var r = this.D.root || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; };

  Packs.prototype.open = function (k) { this.st.ov = k; this.renderOv(); if (k === 'ed') this.render(); var f = qs('.lbp-xb', this.ovs); if (f) f.focus({ preventScroll: true }); };
  Packs.prototype.close = function () { this.st.ov = null; this.render(); };

  Packs.prototype.addClick = function () {
    if (!this.st.picks) { if (this.st.size) { this.allSize(this.st.size); return; } this.open('ask'); return; }
    if (this.missing() > 0) { this.open('ed'); return; }
    this.add();
  };

  Packs.prototype.add = function () {
    var self = this, p = this.pk(), m = {}, order = [], err = qs('[data-lbp-err]', this.root), btn = qs('[data-cta]', this.root);
    this.st.picks.forEach(function (x) { if (!self.ok(x)) return; var id = self.d(x.d)[x.s].id; if (m[id] == null) { m[id] = 0; order.push(id); } m[id]++; });
    var items = order.map(function (id) { return { id: id, quantity: m[id], properties: { _pack: p.label } }; });
    err.hidden = true; btn.classList.add('is-busy');
    this.st.ov = null; this.renderOv();
    fetch(this.root_url() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return window.LNGift && window.LNGift.sync ? window.LNGift.sync({ silent: true }) : null; })
      .then(function () { return fetch(self.root_url() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        self.cart = cart; self.open('cart');
        if (typeof window.refreshCart === 'function') window.refreshCart(false);
        else qsa('[data-header-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
      })
      .catch(function (e) { err.textContent = (e && (e.description || e.message)) || self.T.error; err.hidden = false; })
      .then(function () { btn.classList.remove('is-busy'); });
  };

  Packs.prototype.bind = function () {
    var self = this;
    function act(e) {
      var b = e.target.closest('[data-act]'); if (!b || b.disabled) return;
      var a = b.getAttribute('data-act');
      switch (a) {
        case 'pack': var k = parseInt(b.getAttribute('data-k'), 10); if (k === self.st.pack) self.st.open = !self.st.open; else { self.setPack(k); self.st.open = true; } self.render(); break;
        case 'up': self.setPack(2); self.st.open = true; self.render(); break;
        case 'ed': self.openEd(); break;
        case 'shuffle': self.shuffle(); break;
        case 'add': self.addClick(); break;
        case 'close': self.close(); break;
        case 'size': self.st.size = b.getAttribute('data-s'); self.render(); break;
        case 'allsm': self.allSize('sm'); break;
        case 'allxl': self.allSize('xl'); break;
        case 'mixsizes': self.openEd(); break;
        case 'inc': self.addPick(parseInt(b.getAttribute('data-d'), 10), b.getAttribute('data-s')); self.st.keepScroll = true; self.render(); break;
        case 'dec': self.rmPick(parseInt(b.getAttribute('data-d'), 10), b.getAttribute('data-s')); self.st.keepScroll = true; self.render(); break;
        case 'rmat': self.rmAt(parseInt(b.getAttribute('data-i'), 10)); self.st.keepScroll = true; self.render(); break;
        case 'eddone': self.close(); break;
        case 'thumb': self.goTo(parseInt(b.getAttribute('data-i'), 10) - 1); break;
      }
    }
    this.root.addEventListener('click', act);
    this.ovs.addEventListener('click', act);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.st.ov) self.close(); });
    var track = qs('[data-lbp-galtrack]', this.root);
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        qsa('.lbp-galdots span', self.root).forEach(function (s, j) { s.classList.toggle('on', j === i); });
      }, { passive: true });
    }
  };
  Packs.prototype.goTo = function (i) {
    var track = qs('[data-lbp-galtrack]', this.root); if (!track) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    qsa('.lbp-thumb', this.root).forEach(function (t, j) { t.classList.toggle('on', j === i); });
  };

  /* story: sound button, FAQ into the buy column */
  function story() {
    qsa('[data-lbs-vid]').forEach(function (box) {
      var v = qs('video', box), b = qs('[data-lbs-sound]', box);
      if (!v || !b) return;
      v.muted = true;
      var start = function () {
        if (v.__lbsOn) return; v.__lbsOn = true;
        qsa('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
        v.load(); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); start(); } }); }, { rootMargin: '600px 0px' });
        io.observe(box);
      } else start();
      b.addEventListener('click', function () {
        start(); v.muted = !v.muted; if (!v.muted) { v.currentTime = v.currentTime; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }
        b.classList.toggle('is-on', !v.muted); b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
      });
    });
    /* FAQ items sit under Add to cart (phone and desktop); their own band stays hidden */
    var faq = qs('[data-lbs-faq]'), slot = qs('[data-lbp-faqslot]');
    if (faq && slot && faq.parentNode !== slot) {
      var band = faq.closest ? faq.closest('.lbs-band') : null;
      slot.appendChild(faq); if (band) band.classList.add('is-moved');
    }
  }

  function init() {
    qsa('[data-lbp]').forEach(function (r) { if (!r.__lbp) { r.__lbp = new Packs(r); } });
    story();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
